import React, { useEffect, useState } from "react";
import Header from "../pages/Header";
import Footer from "../pages/Footer";
import { ApiCall, Colors, Web_url } from "../../common/Const";
import { images } from "../../common/Images";
// import girl from "../../assets/girl.webp";
import ReactImageZoom from "react-image-zoom";
// import Cards from "./Cards";
import "../ProductDetailscompnt/productdetail.css";
import { json, useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";

import store from "../../redux/Store";
import Trending from "../pages/homeComponents/Trending";

import EncryptDecrypt from "../../common/Crypto";
import { Accordion, AccordionDetails, AccordionSummary, Avatar, Rating, Typography } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DefImg from "../../assets/avatar.png";
import { ConstructionOutlined, ExitToApp } from "@mui/icons-material";
import { data } from "jquery";


const ReturnDetail = () => {
  const user = useSelector((state) => state.auth.user);
  let { state } = useLocation();
  let { order_detail } = state;
  let { settings } = state;
  const [orderDetails, setOrderDetails] = useState(order_detail);
  const [orderItems, setOrderItems] = useState(orderDetails.order_items);
  const [reasonLists, setReasonLists] = useState([]);
  const [orderId, setOrderId] = useState(orderDetails.id);
  const [disable, setDisable] = useState(false);
  const [reasonDesc, setReasonDesc] = useState([]);


  const navigate = useNavigate();
  const handleReturnitem = (e, item) => {
    e.stopPropagation();
    if (e.target.checked) {
      setOrderItems(orderItems.map(element => {
        if (item.id === element.id) {
          return { ...element, active: true, return_reason: "" }
        }
        else {
          return { ...element }
        }
      })
      )
    }
    else {
      setOrderItems(orderItems.map(element => {
        if (item.id === element.id) {
          return { ...element, active: false, return_reason: "" }
        }
        else {
          return { ...element }
        }
      })
      )
    }

  }
  useEffect(() => {
    setOrderItems(orderItems.map(element => {
      return { ...element, active: false, return_reason: "", validation: false }
    })
    )
    ReasonList();
  }, []);
  const ReasonList = () => {
    ApiCall("reasonList", {
      customer_id: user && user.id > 0 && user.id,
    })
      .then((data) => {
        if (data.message === "Reason listed successfully.") {
          setReasonLists(data.data);
        }
      })
      .catch((err) => console.log(err));
  };

  const returnSubmit = (e) => {
    e.preventDefault();
    setDisable(true)
    const returnItem = [];
    var check = 0;
    setOrderItems(orderItems.map(element => {

      if (element.active && element.return_reason == '') {
        check = 1;
        return { ...element, validation: true }
      }
      else {
        return { ...element, validation: false }
      }
    })
    )
    if (check === 0) {
      orderItems.forEach(element => {
        if (element.active) {
          returnItem.push({ order_item_id: element.id, return_reason: element.return_reason });
        }
      });
      if (returnItem.length > 0) {
        ApiCall("returnOrder", {
          customer_id: user && user.id > 0 && user.id,
          order_id: orderId,
          order_items: JSON.stringify(returnItem),
          return_description: reasonDesc
        })
          .then((data) => {
            if (data.message === "Return placed successfully.") {
              toast.success(data.message, {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              });
              setTimeout(
                () =>
                  navigate("/myorder"),
                3000
              );
            }
            else {
              setDisable(false)
              toast.success(data.message, {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              });
            }
          })
          .catch((err) => console.log(err));
      }
      else {
        setDisable(false)
        toast.success("select products to return", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });

      }
    }
    else {
      setDisable(false)
    }

  };

  const handleReason = (item, e) => {

    setOrderItems(orderItems.map(element => {
      if (item === element.id) {
        return { ...element, return_reason: e.target.value }
      }
      else {
        return { ...element }
      }
    })
    )

    console.log(item, 'iiid');
  }

  return (
    <>
      <Header make={true} />
      <section className="return-sec py-5">
        <form>
          <div className="container">
            <p className="return-head">My Orders</p>
            {
              orderItems.length > 0 ?
                orderItems.map((order_item, i) => {
                  return (
                    <div className="order-itm" key={i}>
                      <div className="row justify-content-center">
                        <p className="col-11 del-status p-0">Delivered &nbsp;<span>Shipment  {i + 1}/{orderItems.length}</span></p>
                        <hr className="col-11 p-0"></hr>
                        <div className="col-md-11 py-3">
                          <div className="o-list">
                            {
                              order_item.return_status == 1 ?
                                <input type="checkbox" onClick={(e) => handleReturnitem(e, order_item)} />
                                : null
                            }
                            <picture className="r-image"><img src={Web_url.Domain_url + order_item.product_image} className="" alt="product"
                            ></img></picture>
                            <p className="return-pro">{order_item.product_name}
                            <br></br>
                            <span style={{ color: "#126a38", fontSize: "16px" }}>{order_item.variant.varient}</span>
                            <br></br> <span>{settings != '' ? settings.currency.symbol : ''} {order_item.order_price} * {order_item.quantity} </span>
                              {/* {
                                order_item.return_status === 1 ? <span style={{ color: "red", fontSize: "16px" }}>Return will expire on  {moment(orderDetails.updated_at).add(settings.return_days, "days").format('DD-MMM-yyyy')}</span> : null
                              } */}
                              
                              <br></br>
                              {
                                order_item.return_status === 2 ? <span style={{ color: "red", fontSize: "16px" }}>Return not available</span> : null
                              }
                            </p>

                          </div>
                        </div>
                        <hr className="col-11 p-0"></hr>
                      </div>
                      <div className="row justify-content-center">
                        {
                          order_item.active ?
                            <div className="col-11 choose-reason" id={order_item.id}>
                              <label className="reason-label">Reason For Return </label>
                              <select className="form-select form-select my-2 col-8" aria-label=".form-select-lg example" onChange={(e) => handleReason(order_item.id, e)}>
                                <option defaultValue={1} value=''>Choose return reason</option>
                                {
                                  reasonLists.length > 0 ? (
                                    reasonLists.map((reasonList, index) => {
                                      return (
                                        <option key={index} value={reasonList.label}>{reasonList.label}</option>
                                      )
                                    })
                                  ) : null
                                }
                              </select>
                              {
                                order_item.validation ?
                                  <div style={{ color: "red" }}>Select reason</div> : null
                              }
                            </div> : null
                        }
                      </div>
                    </div>
                  )
                }) : null
            }
            <div className="row mt-3">
              <div className="col-12 p-2">
                <label className="reason-label">More Details</label>
                <textarea className="return-first mt-2" name="reason_description" onChange={(e) => setReasonDesc(e.target.value)} rows="7" autoComplete="off"></textarea>
              </div>
            </div>
            <div className="return-action">
              <button type="button" className="send-return-btn" onClick={returnSubmit} disabled={disable}>Send Request</button>
              <button type="button" className="cancel-return-btn" onClick={() => navigate(-1)}>cancel</button>
            </div>
          </div>
        </form>
      </section>
      <Footer />
      <ToastContainer />
    </>
  );
}

export default ReturnDetail;
